<template>
  <div>
    <b-row>
      <b-col>
        <header-view
          :title="title"
          icon="ti-agenda">
        </header-view>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <b-alert
          class="rounded-0"
          variant="warning"
          :show="true">
          {{ $t('message.adminContractPartnerDetails.warning') }}
        </b-alert>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <b-card class="rounded-0">
          <admin-contract-partner-form
            @onCancel="cancel"
            @onSave="saveContractPartner">
          </admin-contract-partner-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import AdminContractPartnerForm from '@/components/admin/AdminContractPartnerForm'
  import HeaderView from '@/components/common/HeaderView'
  export default {
    name: 'AdminContactPartnerDetails',
    beforeRouteEnter (to, from, next) {
      next(vm => {
        if (to.params && to.params.id) {
          vm.$store.dispatch('fetchAdminContractPartnerById', parseInt(to.params.id))
            .catch(() => {
              vm.showErrorMsg({
                message: vm.$t('error.adminContractPartnerDetails.fetchAdminContractPartnerById')
              })
              vm.$router.replace('/admin/contractpartners')
            })
        } else {
          vm.$router.replace('/admin/contractpartners')
        }
      })
    },
    components: {
      AdminContractPartnerForm,
      HeaderView
    },
    computed: {
      contractPartner () {
        return this.$store.getters.adminContractPartner
      },
      title () {
        return this.$t('message.adminContractPartnerDetails.title')
      }
    },
    methods: {
      cancel () {
        this.$router.push('/admin/contractpartners')
      },
      saveContractPartner () {
        this.$store.dispatch('storeAdminContractPartnerTemplate', this.contractPartner)
          .then(() => {
            this.showSuccessMsg({
              message: this.$t('message.adminContractPartnerDetails.saveContractPartner')
            })
            this.$router.push('/admin/contractpartners')
          })
          .catch(() => this.showErrorMsg({
            message: this.$t('error.adminContractPartnerDetails.saveContractPartner')
          }))
      }
    },
    notifications: {
      showErrorMsg: {
        type: 'error'
      },
      showSuccessMsg: {
        type: 'success'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/AdminContractPartnerDetails.vue